import { DatesRangeCriteria } from '../entities';

export const weekdaysDateFilter =
  (criteria: DatesRangeCriteria | null | undefined) =>
  (date: Date): boolean => {
    if (!criteria) return false;
    if (!criteria.weekdays) return true;

    return criteria.weekdays.includes(date.getDay());
  };
